// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import api from "../api/axiosInstance";

// // Pulls a clean, consistent message out of an axios error.
// const getErrorMessage = (err, fallback) =>
//   err.response?.data?.message || fallback;

// // --- Thunks -----------------------------------------------------------

// export const registerUser = createAsyncThunk(
//   "auth/registerUser",
//   async ({ name, email, password, role, contact }, { rejectWithValue }) => {
//     try {
//       const res = await api.post("/user/register", { name, email, password, role, contact });
//       return res.data.user;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Registration failed."));
//     }
//   }
// );

// export const loginUser = createAsyncThunk(
//   "auth/loginUser",
//   async ({ email, password }, { rejectWithValue }) => {
//     try {
//       const res = await api.post("/user/login", { email, password });
//       return res.data.user;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Login failed."));
//     }
//   }
// );

// export const logoutUser = createAsyncThunk(
//   "auth/logoutUser",
//   async (_, { rejectWithValue }) => {
//     try {
//       await api.post("/user/logout");
//       return true;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Logout failed."));
//     }
//   }
// );

// // Checks for an existing session (httpOnly cookie) when the app first loads.
// export const fetchCurrentUser = createAsyncThunk(
//   "auth/fetchCurrentUser",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await api.get("/user/me");
//       return res.data.user;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Not authenticated."));
//     }
//   }
// );

// // --- Slice --------------------------------------------------------------

// const initialState = {
//   user: null,
//   status: "idle", // idle | loading | succeeded | failed
//   error: null,
//   initialized: false, // true once the initial /user/me check has resolved
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     clearAuthError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Register
//       .addCase(registerUser.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(registerUser.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.user = action.payload;
//       })
//       .addCase(registerUser.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })

//       // Login
//       .addCase(loginUser.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.user = action.payload;
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload;
//       })

//       // Logout
//       .addCase(logoutUser.fulfilled, (state) => {
//         state.user = null;
//         state.status = "idle";
//       })

//       // Fetch current user (session check on app load)
//       .addCase(fetchCurrentUser.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(fetchCurrentUser.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.user = action.payload;
//         state.initialized = true;
//       })
//       .addCase(fetchCurrentUser.rejected, (state) => {
//         state.user = null;
//         state.status = "idle";
//         state.initialized = true;
//       });
//   },
// });

// export const { clearAuthError } = authSlice.actions;
// export default authSlice.reducer;


// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import api from "../api/axiosInstance";

// // Pulls a clean, consistent message out of an axios error.
// const getErrorMessage = (err, fallback) =>
//   err.response?.data?.message || fallback;

// // Message + machine-readable code (e.g. "EMAIL_NOT_VERIFIED") from an axios error.
// const getErrorPayload = (err, fallback) => ({
//   message: getErrorMessage(err, fallback),
//   code: err.response?.data?.code || null,
// });

// // --- Thunks -----------------------------------------------------------

// // Registering no longer signs the user in: the backend emails a
// // verification link and returns { message, email } instead of a user.
// export const registerUser = createAsyncThunk(
//   "auth/registerUser",
//   async ({ name, email, password, role, contact }, { rejectWithValue }) => {
//     try {
//       const res = await api.post("/user/register", { name, email, password, role, contact });
//       return { message: res.data.message, email: res.data.email };
//     } catch (err) {
//       return rejectWithValue(getErrorPayload(err, "Registration failed."));
//     }
//   }
// );

// export const loginUser = createAsyncThunk(
//   "auth/loginUser",
//   async ({ email, password }, { rejectWithValue }) => {
//     try {
//       const res = await api.post("/user/login", { email, password });
//       return res.data.user;
//     } catch (err) {
//       return rejectWithValue(getErrorPayload(err, "Login failed."));
//     }
//   }
// );

// export const logoutUser = createAsyncThunk(
//   "auth/logoutUser",
//   async (_, { rejectWithValue }) => {
//     try {
//       await api.post("/user/logout");
//       return true;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Logout failed."));
//     }
//   }
// );

// // Checks for an existing session (httpOnly cookie) when the app first loads.
// export const fetchCurrentUser = createAsyncThunk(
//   "auth/fetchCurrentUser",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await api.get("/user/me");
//       return res.data.user;
//     } catch (err) {
//       return rejectWithValue(getErrorMessage(err, "Not authenticated."));
//     }
//   }
// );

// // --- Slice --------------------------------------------------------------

// const initialState = {
//   user: null,
//   status: "idle", // idle | loading | succeeded | failed
//   error: null,
//   // true when the last login/register failed because the email isn't
//   // verified yet; the page then shows a "Resend verification email" button.
//   needsVerification: false,
//   initialized: false, // true once the initial /user/me check has resolved
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     clearAuthError: (state) => {
//       state.error = null;
//       state.needsVerification = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Register
//       .addCase(registerUser.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//         state.needsVerification = false;
//       })
//       .addCase(registerUser.fulfilled, (state) => {
//         // User is NOT signed in yet; they must click the emailed link first.
//         state.status = "succeeded";
//       })
//       .addCase(registerUser.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload?.message || "Registration failed.";
//         state.needsVerification = action.payload?.code === "EMAIL_NOT_VERIFIED";
//       })

//       // Login
//       .addCase(loginUser.pending, (state) => {
//         state.status = "loading";
//         state.error = null;
//         state.needsVerification = false;
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.user = action.payload;
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.status = "failed";
//         state.error = action.payload?.message || "Login failed.";
//         state.needsVerification = action.payload?.code === "EMAIL_NOT_VERIFIED";
//       })

//       // Logout
//       .addCase(logoutUser.fulfilled, (state) => {
//         state.user = null;
//         state.status = "idle";
//       })

//       // Fetch current user (session check on app load)
//       .addCase(fetchCurrentUser.pending, (state) => {
//         state.status = "loading";
//       })
//       .addCase(fetchCurrentUser.fulfilled, (state, action) => {
//         state.status = "succeeded";
//         state.user = action.payload;
//         state.initialized = true;
//       })
//       .addCase(fetchCurrentUser.rejected, (state) => {
//         state.user = null;
//         state.status = "idle";
//         state.initialized = true;
//       });
//   },
// });

// export const { clearAuthError } = authSlice.actions;
// export default authSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/axiosInstance";
import { announceSessionChange } from "../utils/sessionSync";

// Pulls a clean, consistent message out of an axios error.
const getErrorMessage = (err, fallback) =>
  err.response?.data?.message || fallback;

// Message + machine-readable code (e.g. "EMAIL_NOT_VERIFIED") from an axios error.
const getErrorPayload = (err, fallback) => ({
  message: getErrorMessage(err, fallback),
  code: err.response?.data?.code || null,
});

// --- Thunks -----------------------------------------------------------

// Registering no longer signs the user in: the backend emails a
// verification link and returns { message, email } instead of a user.
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async ({ name, email, password, role, contact }, { rejectWithValue }) => {
    try {
      const res = await api.post("/user/register", { name, email, password, role, contact });
      return { message: res.data.message, email: res.data.email };
    } catch (err) {
      return rejectWithValue(getErrorPayload(err, "Registration failed."));
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const res = await api.post("/user/login", { email, password });
      // The cookie is shared by every tab — tell the other tabs who is
      // signed in now so they reload instead of showing the old user.
      announceSessionChange("login", res.data.user?.id || res.data.user?._id);
      return res.data.user;
    } catch (err) {
      return rejectWithValue(getErrorPayload(err, "Login failed."));
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      await api.post("/user/logout");
      // Other tabs were using the same cookie — send them to the login page.
      announceSessionChange("logout");
      return true;
    } catch (err) {
      return rejectWithValue(getErrorMessage(err, "Logout failed."));
    }
  }
);

// Checks for an existing session (httpOnly cookie) when the app first loads.
export const fetchCurrentUser = createAsyncThunk(
  "auth/fetchCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/user/me");
      return res.data.user;
    } catch (err) {
      return rejectWithValue(getErrorMessage(err, "Not authenticated."));
    }
  }
);

// --- Slice --------------------------------------------------------------

const initialState = {
  user: null,
  status: "idle", // idle | loading | succeeded | failed
  error: null,
  // true when the last login/register failed because the email isn't
  // verified yet; the page then shows a "Resend verification email" button.
  needsVerification: false,
  initialized: false, // true once the initial /user/me check has resolved
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuthError: (state) => {
      state.error = null;
      state.needsVerification = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Register
      .addCase(registerUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.needsVerification = false;
      })
      .addCase(registerUser.fulfilled, (state) => {
        // User is NOT signed in yet; they must click the emailed link first.
        state.status = "succeeded";
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Registration failed.";
        state.needsVerification = action.payload?.code === "EMAIL_NOT_VERIFIED";
      })

      // Login
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.needsVerification = false;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Login failed.";
        state.needsVerification = action.payload?.code === "EMAIL_NOT_VERIFIED";
      })

      // Logout
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.status = "idle";
      })

      // Fetch current user (session check on app load)
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
        state.initialized = true;
      })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.user = null;
        state.status = "idle";
        state.initialized = true;
      });
  },
});

export const { clearAuthError } = authSlice.actions;
export default authSlice.reducer;